/* SIFT · back-in-stock capture.

   The form is a plain Shopify `customer` form posting to /contact, not an AJAX
   call. That is deliberate: Shopify answers the post with a redirect, and
   `form.posted_successfully?` in Liquid is the only account of the outcome that
   cannot disagree with what the server actually did.

   The wrinkle is that a theme usually has a second `customer` form in the
   footer, and Shopify reports success to every customer form on the page, not
   just the one that was posted. So a footer newsletter signup would otherwise
   pop this dialog open saying "you'll be first to know". A flag written to
   sessionStorage immediately before submitting is what tells the two apart:
   Liquid decides whether a customer form succeeded, this decides whether it
   was ours. */
(function () {
  'use strict';

  var KEY = 'siftNotifyPending';
  var root = null;
  var lastFocus = null;

  function $(id) { return document.getElementById(id); }

  function session(op, val) {
    try {
      if (op === 'get') return window.sessionStorage.getItem(KEY);
      if (op === 'set') return window.sessionStorage.setItem(KEY, val);
      window.sessionStorage.removeItem(KEY);
    } catch (err) { /* private mode — the dialog still works, it just cannot
                       recognise its own success after the redirect */ }
    return null;
  }

  function setText(el, val) { if (el) el.textContent = val || ''; }

  function open(opts) {
    if (!root) return;
    opts = opts || {};

    var done = !!document.getElementById('snPosted') && opts.done;
    var form = $('snForm');
    var doneBox = $('snDone');
    if (form) form.hidden = !!done;
    if (doneBox) doneBox.hidden = !done;

    /* Which thing is out of stock. Falls back to the page's own product so the
       dialog is never anonymous — "notify me about what?" is the fastest way
       to lose the address. */
    var what = opts.title || root.dataset.product || '';
    setText($('snWhat'), what);

    var img = $('snImg');
    if (img) {
      if (opts.image) { img.src = opts.image; img.hidden = false; }
      else { img.hidden = true; }
    }

    /* Tags are the whole point of the capture: they are what turns a pile of
       customers into a segment the merchant can actually mail when the stock
       lands. Anything falsy is dropped so no empty tag reaches the customer. */
    var tags = $('snTags');
    if (tags) {
      tags.value = [root.dataset.baseTag || 'back-in-stock']
        .concat(opts.tags || [])
        .filter(Boolean)
        .join(', ');
    }

    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    var focusTarget = done ? $('snCloseDone') : $('snEmail');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 30);
  }

  function close() {
    if (!root || root.hidden) return;
    root.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  /* Product pages outside the SIFT template get a best-effort trigger: only
     when Liquid has already said the product is sold out, so a mis-guessed
     selector can add a button in the wrong place but can never offer a
     back-in-stock alert for something that is in stock. */
  function injectFallback() {
    if (!root || root.dataset.soldOut !== 'true') return;
    if (document.querySelector('[data-sn-open]')) return;

    var addBtn = document.querySelector(
      'form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"]'
    );
    if (!addBtn || !addBtn.disabled) return;

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sn-go';
    b.style.marginTop = '10px';
    b.textContent = root.dataset.cta || 'Email me when it is back';
    b.setAttribute('data-sn-open', '');
    addBtn.parentNode.insertBefore(b, addBtn.nextSibling);
  }

  function init() {
    root = $('siftNotify');
    if (!root || root.dataset.snInit) return;
    root.dataset.snInit = '1';

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sn-close]')) { close(); return; }
      var trigger = e.target.closest('[data-sn-open]');
      if (!trigger) return;
      e.preventDefault();
      var tags = (trigger.getAttribute('data-sn-tags') || '').split(',');
      open({
        title: trigger.getAttribute('data-sn-title'),
        image: trigger.getAttribute('data-sn-image'),
        tags: tags
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) close();
    });

    var post = $('siftNotifyPost');
    if (post) {
      /* set only on a real submit, which fires after the browser's own email
         validation has passed — a rejected address never arms the flag */
      post.addEventListener('submit', function () {
        session('set', $('snWhat') ? $('snWhat').textContent : '1');
      });
    }

    /* Back from the redirect. Liquid has told us a customer form succeeded;
       the flag tells us it was this one rather than the footer newsletter. */
    var pending = session('get');
    if (document.getElementById('snPosted') && pending) {
      session('clear');
      open({ done: true, title: pending });
    }

    injectFallback();
  }

  window.siftNotify = { open: open, close: close };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
